export const SUCCESS = 'success';

export const ERROR = 'error';

export const COPY_EMAIL = 'メールアドレスをコピーしました';
